import api from '../api/client';

export const leiloeirosService = {
  listar: (organizadorId) => api.get(`/organizadores/${organizadorId}/leiloeiros`),
  
  buscarPorId: (organizadorId, id) => api.get(`/organizadores/${organizadorId}/leiloeiros/${id}`),
  
  criar: (organizadorId, dados) => api.post(`/organizadores/${organizadorId}/leiloeiros`, dados),
  
  atualizar: (organizadorId, id, dados) => api.put(`/organizadores/${organizadorId}/leiloeiros/${id}`, dados),
  
  excluir: (organizadorId, id) => api.delete(`/organizadores/${organizadorId}/leiloeiros/${id}`)
};
